export const MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST = "MANUFACTURERS_OVERVIEW_GET_DATA_REQUEST";
export const MANUFACTURERS_OVERVIEW_GET_DATA_RESULT = "MANUFACTURERS_OVERVIEW_GET_DATA_RESULT";